module.exports = __webpack_public_path__ + "media/assets/icons/triangle-right-5f713ac0dc83f053759c21ae8b98d665.svg";